import { lazy } from 'react';

import { AuthRoute } from 'modules/auth/routes/auth-route';

const Profile = lazy(() => import('./profile'));

export default {
  routes: [<AuthRoute exact key="/profile" path="/profile" render={() => <Profile />} />],
};
